<template>

    <!-- 推广商品 -->
    <Promotional v-bind="getBindValues" v-if="topicDetail.goods_type === 2" />
    <!-- 普通商品 -->
    <Genera v-bind="getBindValues" v-else />

</template>

<script setup>
import { ref, unref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { getTopicDetail, getTopicGoods } from "@/api/topic";
import Genera from "./General.vue";
import Promotional from "./Promotional.vue";
import { useAuth } from "@/hooks/useAuth";


const route = useRoute();
const { tid } = route.query;
const topicDetail = ref({});
const goodsList = ref([]);
async function init() {
  const [detail, goods] = await Promise.all([
    getTopicDetail({ id: tid }),
    getTopicGoods({ id: tid }),
  ]);
  topicDetail.value = detail.data;
  goodsList.value = goods.data.data;
}
const getBindValues = computed(() => ({
  topicDetail: unref(topicDetail),
  goodsList: unref(goodsList),
}));
// 授权钩子
useAuth(
  {
    auth_type: 2,
  },
  () => init()
);
</script>

